const sendEvent$ = 'analytics/sendEvent$';
const sendUnIdentifiedEvent$ = 'analytics/sendUnIdentifiedEvent$';

export default {
  sendEvent$,
  sendUnIdentifiedEvent$,
};
